import * as types from "../../common/state/actionTypes";

export function saveStartDate(startDate) {
  return { type: types.SAVE_DATA_ANALYSIS_START_DATE, startDate: startDate };
}

export function saveEndDate(endDate) {
  return { type: types.SAVE_DATA_ANALYSIS_END_DATE, endDate };
}
